import $ from 'jquery';

$( window ).on( 'load', () => {
  let pageSlug = window.location.pathname.replaceAll("/", '')

  $( `.nav-link[data-slug="${ pageSlug }"]` ).parent().addClass( 'active' );

  $( '.nav-handle' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' )
    $( 'body' ).toggleClass( 'no-scroll' );
  } )

  $( '.floor-plan-toggle' ).on( 'click', () => {
    let floorPlansMobile = $( '.floor-plans-mobile' );

    $( floorPlansMobile ).toggleClass( 'active' );
    $( floorPlansMobile ).hasClass( 'active' ) ? $( floorPlansMobile ).css( 'max-height', $( floorPlansMobile )[0].scrollHeight ) : $( floorPlansMobile ).css( 'max-height', '0' )
  } )

  $( 'p.main-nav-title' ).on( 'click', ( elem ) => {
    let $this = $( elem.currentTarget );

    if( $this.hasClass( 'active' ) ) {
      $this.removeClass( 'active' )
      $( '.nav' ).removeClass( 'sub-active' );
    } else {
      $( '.main-nav-title' ).removeClass( 'active' )
      $this.addClass( 'active' )
      $( '.nav' ).addClass( 'sub-active' );
    }
  } )

  $( 'main' ).on( 'click', () => {
    $( 'p.main-nav-title' ).removeClass( 'active' )
  } )

  if( $( '.page-header' ).length ) {
    var position = $( window ).scrollTop();
    var navHeight = $( '.nav' ).height();
    var headerHeight = $( '.page-header' ).height() + navHeight;
    // should start at 0


    $( window ).on( 'scroll', () => {
      var scroll = $( window ).scrollTop();
      //if the user scrolls past the navigation height, adds position fixed
      // and translates the menu -100%;
      if ( scroll >= navHeight ) {
        $( '.nav' ).addClass( 'nav-fix' );
        $( '.main-nav-title' ).removeClass( 'active' );
        $( '.nav' ).removeClass( 'sub-active' );
      } else {
        $( '.nav' ).removeClass( 'nav-fix' );
      }
      // when the user scrolls page the hero, adds a nav-animate class so
      // the fixed nav can now animate
      if( scroll > position || scroll <= navHeight) {
        $( '.nav' ).removeClass( 'nav-animate' );
      } else {
        $( '.nav' ).addClass( 'nav-animate' );
      }
      position = scroll;
      // when the user makes an upwards scroll the nav translates to 0%
      // if it has the nav-animate class also
      if ( scroll >= headerHeight ) {
        $( '.nav' ).addClass( 'nav-show' );
      } else {
        $( '.nav' ).removeClass( 'nav-show' );
      }
    });
  }
});